<template>
  <div class="w-full bg-zt-light/35 py-3 h-[129px] rounded-zt border-y border-zt-light mb-4 border-x xl:px-2 xl:h-[127px]">
    <div class="px-2 flex gap-2 mb-3">
      <div class="w-[56px] h-[56px] p-[6px] flex items-center justify-center border bg-[#eee] border-zt-light-bg
                  rounded-zt xl:w-[72px]"
           :class="{ '!bg-white': ['spvgg-greuther-furth', 'lamia'].includes(teamQueryName) }">
        <img ref="leagueImg" class="max-h-full max-w-full transform-gpu"
             :src="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'"
             :data-src="logo" :alt="name">
      </div>
      <div class="py-1 flex flex-col gap-1">
        <div class="font-semibold flex items-center gap-x-0.5">
          {{ WP.team?.team_short_name ? WP.team.team_short_name : name }}
	        <div v-if="showSeasonText" class="text-zt-more font-normal text-[10px]">
		        ({{ seasonText }})
	        </div>
        </div>
        <div class="flex items-center gap-2">
          <span class="w-[15px] h-[11px]">
            <img ref="CountryImg" class="w-full h-full" :class="{'object-cover overflow-visible' : countryName === 'Świat'}"
                 :src="'/wp-content/themes/zawodtyper/assets/images/staty_football/countryfallback.svg'"
                 :data-src="countryFlag" :alt="countryName">
          </span>
          <a v-if="navType === 'team' && WP.team.country === 'World' && WP.team.team_representation_name !== null" class="text-sm text-zt-more no-default-style zt-hover"
             :href="`/wyniki-pilka-nozna/reprezentacje/`"
             data-count-click="DRUŻYNA -> Reprezentacja w nagłówku drużyny underline">
            Reprezentacje
          </a>
          <a v-else-if="navType === 'team' && WP.team.country !== 'World'" :href="`/wyniki-pilka-nozna/${countryQueryName}/${leagueQueryName}`"
             data-count-click="DRUŻYNA -> Liga w nagłówku drużyny"
             class="no-default-style zt-hover text-zt-more text-sm underline">
            {{ leagueName }}
          </a>
          <a v-else :href="`/wyniki-pilka-nozna/${countryQueryName}/`"
             data-count-click="LIGA -> kraj w nagłówku ligi"
             class="no-default-style zt-hover text-zt-more text-sm underline">
            {{ countryName }}
          </a>
        </div>
      </div>
    </div>
    <hr class="border-zt-light border mr-2 mb-2.5">
	  <div class="swiper swiper-nav overflow-hidden -mb-[6px] px-1" v-if="navType === 'league'">
		  <div class="text-zt-more pb-[6px] text-sm font-medium uppercase swiper-wrapper">
			  <a data-count-click="LIGA - przełącznik główny"
           :href="navigationItem.text === 'typy' ? `${navigationItem.link}` : `/wyniki-pilka-nozna/${countryQueryName}/${leagueQueryName}/${navigationItem.link}`"
           v-for="(navigationItem, index) of navigationItems"
			     :class="{ 'text-zt-red border-zt-red': getCurrentTab() === navigationItem.link
			       || (window.location.pathname.split('/').length === 5 && navigationItem.link === '') }"
			     class="zt-hover no-default-style uppercase relative after:block border-b border-zt-more swiper-slide">
				  {{ navigationItem.text }}
				  <span v-if="navigationItem.text === 'typy'">
					  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" class="ml-[2px]" viewBox="0 0 13 13" fill="none">
					    <path d="M8.40547 12.0636L12.9993 6.50004L8.40547 0.936523L7.65519 1.84518L10.9854 5.86239L2.62695 5.86239V7.13769L10.9854 7.13769L7.65519 11.1549L8.40547 12.0636Z" fill="#93A3BA"/>
						  <path d="M1.05303 5.86133H0L0 7.13663H1.05303L1.05303 5.86133Z" fill="#93A3BA"/>
						</svg>
				  </span>
			  </a>
		  </div>
		  <div ref="scrollbarSwiperEl" class="scrollbar-nav !h-[2px] bg-[#3a4b6480] !opacity-100 !cursor-default"></div>
	  </div>
	  <div class="swiper-nav overflow-hidden px-1 -mb-[6px]" v-else-if="navType==='team'">
			<div class="flex text-zt-more pb-[6px] text-sm font-medium uppercase swiper-wrapper">
			  <button @click="handleClick(navigationItem.link)"
                v-for="navigationItem of navigationItems"
                :class="{ 'text-zt-red border-zt-red': getCurrentTab() === navigationItem.link
                  || (window.location.pathname.split('/').length === 5 && navigationItem.link === 'przegląd') }"
                class="zt-hover uppercase relative after:block border-b border-zt-more swiper-slide">
				  {{ navigationItem.text }}
			  </button>
		  </div>
		  <div ref="scrollbarSwiperEl" class="scrollbar-nav !h-[2px] bg-[#3a4b6480] !opacity-100 !cursor-default"></div>
	  </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import { FreeMode, Scrollbar } from 'swiper/modules';
import utils_mixin from '../../mixins/utils_mixin';
import { countVisit } from '../../../assets/js/utils';

export default {
  name: 'FootballStatsNavigation',
	inject: ['WP'],
  emits: ['tabChanged'],
	mixins: [utils_mixin],
  props: {
    leagueId: String,
    leagueType: String,
    countryQueryName: String,
	  leagueGroupStage: String,
		leagueQueryName: String,
		leagueName: String,
		teamQueryName: String,
	  season: String,
    seasonType: String,
		name: String,
		countryPolishName: String,
		navType: {
			type: String,
			default: 'league',
		},
		activeTab: {
			type: String,
			default: '',
		}
  },
  data() {
    return {
      currentTab: this.activeTab,
	    leaguesWithoutSeason: [100009, 9, 4, 100005, 100011, 100012, 15, 480],
      europeanCupsWithSeasons: [2, 3, 848, 15],
      euroAndCopaTeamIds: [ // Euro 2024 + Argentyna, Brazylia, Kolumbia, Urugwaj
        25, 769, 1108, 15, 778, 3, 768, 9, 21, 10, 14, 1091, 775, 2, 1118, 24, 1, 774, 773, 772, 770, 1104, 27, 777, 26, 6, 8, 7, 769, 770
      ],
    }
  },
  computed: {
		showSeasonText() {
      if ([38,6,743,22].includes(+this.leagueId)) {
        return true;
      }
			if ((this.navType !== 'league' || this.season === '' || this.leaguesWithoutSeason.includes(+this.leagueId)
				|| this.leagueType === 'European Cup' || this.leagueType === 'National Cup') && !this.europeanCupsWithSeasons.includes(+this.leagueId)) {
				return false;
			}
			return true;
		},
	  seasonText() {
			if ([45, 143, 66].includes(+this.leagueId)) return '2024/25';
      //wyjatek superpuchar hiszpanii
      if (+this.leagueId === 556) return +this.season + 1;
			return this.seasonType === 'year' ? this.season : `${this.season}/${(+this.season + 1).toString().slice(2, 4)}`;
	  },
    countryFlag() {
      return `/wp-content/themes/zawodtyper/assets/images/kraje/${this.countryQueryName.toLowerCase()}.svg`;
    },
    logo() {
      if (this.navType === 'league') {
        let extension = 'png';
        if (Number(this.leagueId) === 286) { // Tymczasowe rozwiązanie na to, że akurat jedno logo jest w svg -.-
          extension = 'svg';
        }
        return `/wp-content/themes/zawodtyper/assets/images/ligi/${this.countryQueryName}-${this.leagueQueryName}.${extension}`;
      } else {
        return `/wp-content/themes/zawodtyper/assets/images/druzyny/${this.teamQueryName}.png`;
      }
    },
    countryName() {
      return this.countryPolishName;
    },
    navigationItems() {
	    if ((this.leagueType === 'European Cup' || this.leagueType === 'National Cup') && this.leagueGroupStage === '0') {
		    let items = [
			    {
				    text: 'przegląd',
				    link: '',
			    },
			    {
				    text: 'wyniki',
				    link: 'wyniki/',
			    },
			    {
				    text: 'terminarz',
				    link: 'terminarz/',
			    },
          {
            text: 'drabinka',
            link: 'drabinka/',
          },
          {
				    text: 'strzelcy',
				    link: 'strzelcy/',
			    },
			    {
				    text: 'historia',
				    link: 'historia/',
			    },
		    ];
		    if (+this.leagueId === 2) {
			    items.splice(5,0, {
				    text: 'typy',
				    link: '/typy-na-lige-mistrzow/',
			    });
          items.splice(3,0, {
            text: 'tabela',
            link: 'tabela/',
          });
          items.push({
            text: 'kwalifikacje',
            link: 'kwalifikacje/',
          });
		    }
        if ([1, 100005].includes(+this.leagueId)) {
          items.splice(1, 0, {
            text: 'Eliminacje',
            link: 'kwalifikacje/',
          });
        }
        if ([3, 848].includes(+this.leagueId)) {
          items.splice(4, 1, {
            text: 'tabela',
            link: 'tabela/',
          });
        }
				return items;
	    }
	    if ((this.leagueType === 'European Cup' || this.leagueType === 'National Cup') && this.leagueGroupStage === '1') {
		    let items = [
			    {
				    text: 'przegląd',
				    link: '',
			    },
			    {
				    text: 'wyniki',
				    link: 'wyniki/',
			    },
			    {
				    text: 'terminarz',
				    link: 'terminarz/',
			    },
			    {
				    text: 'grupy',
				    link: 'grupy/',
			    },
          {
            text: 'drabinka',
            link: 'drabinka/',
          },
          {
				    text: 'strzelcy',
				    link: 'strzelcy/',
			    },
			    {
				    text: 'historia',
				    link: 'historia/',
			    },
		    ];
        if (+this.leagueId === 480) {
          items.splice(5,1, {
            text: 'typy',
            link: '/typy-na-pilkarskie-igrzyska-olimpijskie/',
          });
        }
				if (+this.leagueId === 4) {
					items.splice(6, 0, {
						text: 'typy',
						link: '/typy-na-euro/',
					});
				}
				if (+this.leagueId === 9) {
					items.splice(6, 0, {
						text: 'typy',
						link: '/typy-copa-america/',
					});
				}
        if (+this.leagueId === 15) {
          items.splice(6,0, {
            text: 'typy',
            link: '/klubowe-mistrzostwa-swiata-typy/',
          });
        }
        if (+this.leagueId === 743) {
          items.splice(5,1);
        }
        return items;
	    }
			if (this.leagueType === 'Cup') {
        if(+this.leagueId === 913) {
          return [
            {
              text: 'przegląd',
              link: '',
            },
            {
              text: 'wyniki',
              link: 'wyniki/',
            },
            {
              text: 'terminarz',
              link: 'terminarz/',
            },
            {
              text: 'historia',
              link: 'historia/',
            },
          ];
        }
        return [
          {
            text: 'przegląd',
            link: '',
          },
          {
            text: 'wyniki',
            link: 'wyniki/',
          },
          {
            text: 'terminarz',
            link: 'terminarz/',
          },
          {
            text: 'drabinka',
            link: 'drabinka/',
          },
          {
            text: 'strzelcy',
            link: 'strzelcy/',
          },
          {
            text: 'historia',
            link: 'historia/',
          },
        ];
			}
			if (this.leagueType === 'Supercup') {
				let items = [
					{
						text: 'przegląd',
						link: '',
					},
					{
						text: 'wyniki',
						link: 'wyniki/',
					},
					{
						text: 'terminarz',
						link: 'terminarz/',
					},
					{
						text: 'historia',
						link: 'historia/',
					},
				];
        if ([547, 556].includes(+this.leagueId)) {
          items.splice(3,0, {
            text: 'drabinka',
            link: 'drabinka/',
          });
        }
        return items;
			}
      if (this.navType === 'league') {
        return [
          {
            text: 'przegląd',
            link: '',
          },
	        {
		        text: 'wyniki',
		        link: 'wyniki/',
	        },
	        {
		        text: 'terminarz',
		        link: 'terminarz/',
	        },
          {
            text: 'tabela',
            link: 'tabela/',
          },
          {
            text: 'statystyki',
            link: 'statystyki/',
          },
          {
            text: 'strzelcy',
            link: 'strzelcy/',
          },
          {
            text: 'historia',
            link: 'historia/',
          },
        ];
      } else if (this.navType === 'team') {
        if (this.WP.team.country === 'World') {
          let list = [
            {
              text: 'przegląd',
              link: 'przegląd',
            },
            {
              text: 'wyniki',
              link: 'wyniki',
            },
            {
              text: 'terminarz',
              link: 'terminarz',
            },
          ];
					if (+this.WP.team.league_id === 4) {
						list.push({
							text: 'strzelcy',
							link: 'strzelcy',
						});
					}
          if (+this.WP.team.team_show_squad === 1) {
            list.push({
                text: 'kadra',
                link: 'kadra',
              });
          }
          return list;
        } else {
          return [
            {
              text: 'przegląd',
              link: 'przegląd',
            },
            {
              text: 'tabela',
              link: 'tabela',
            },
            {
              text: 'wyniki',
              link: 'wyniki',
            },
            {
              text: 'terminarz',
              link: 'terminarz',
            },
            {
              text: 'strzelcy',
              link: 'strzelcy',
            },
            {
              text: 'historia',
              link: 'historia',
            },
          ];
        }
      }
    },
    currentUrl() {
      return window.location.pathname;
    },
    swiperActiveSlideIndex() {
      if (this.navType === 'league') {
        let currentTab = this.currentUrl.split('/');
        currentTab = currentTab[currentTab.length - 2];
        const slideIndices = this.navigationItems.slice().map((item) => item.link.split('/')[0]);
        return slideIndices.indexOf(currentTab) || 0;
      }
    },
  },
  mounted() {
	  this.swiper = new Swiper('.swiper-nav', {
		  modules: [Scrollbar, FreeMode],
		  slidesPerView: 'auto',
		  initialSlide: this.swiperActiveSlideIndex,
		  resistanceRatio: 0,
      // 566px is width of the swiper containter without scrolls, fixes right aligning items on wide mobile devices 
		  centeredSlidesBounds: (window.size.width < 566 && this.leagueType !== 'Cup' && this.leagueType !== 'Supercup' && this.WP.team?.country !== 'World') || +this.leagueId === 2,
		  centeredSlides: (window.size.width < 566 && this.leagueType !== 'Cup' && this.leagueType !== 'Supercup' && this.WP.team?.country !== 'World') || +this.leagueId === 2,
      freeMode: {
			  enabled: true,
			  minimumVelocity: 0.01,
			  momentum: true,
			  momentumBounce: false,
			  momentumRatio: 0.7,
			  momentumVelocityRatio: 0.5,
			  sticky: false,
		  },
		  scrollbar: {
			  el: '.scrollbar-nav',
			  draggable: false,
			  hide: true,
		  },
		  spaceBetween: 16,
	  });
    this.$nextTick(() => lazyLoad([this.$refs.leagueImg, this.$refs.CountryImg]));
	  this.swiper.on('sliderFirstMove', () => this.$refs.scrollbarSwiperEl.classList.remove('!opacity-100'));
    this.removePlaceholder(this.$attrs.component);
    this.emitter.on('change-football-nav-tab', tab => {
      this.currentTab = tab;
    });
    if (this.navType === 'league') {
      setTimeout(() => loadScrollPositionState(window.location.pathname), 800);
    }
  },
  methods: {
    getCurrentTab() {
      let tab = this.currentTab || window.location.pathname.split('/').at(-2);
      if (this.navType === 'league') {
        tab += '/';
      }
      return tab;
    },
    handleClick(tab) {
      this.emitter.emit('football-nav-tab-changed', tab);
      this.currentTab = tab;
      let index = this.navigationItems.findIndex(el => {
        return el.text === tab;
      });
      if (index !== -1) {
        this.swiper.slideTo(index, 200);
      }
      countClicks('DRUŻYNA - kliknięcia w główny przełącznik');
      countVisit();
    }
  }
}
</script>

<style scoped>
.swiper-slide {
	@apply !flex !items-center !justify-center !w-fit;
}
</style>